module.exports = __webpack_public_path__ + "img/yatao_yang.1e03d09c.jpg";